import { __assign, __extends, __makeTemplateObject, __rest } from "tslib";
import { faBars } from '@fortawesome/free-solid-svg-icons/faBars';
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { compose, withProps } from 'recompose';
import styled from 'styled-components';
import { Box } from '../Box';
import { Container } from '../Container';
import { Flex } from '../Flex';
var BrandBox = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: flex;\n\talign-self: center;\n"], ["\n\tdisplay: flex;\n\talign-self: center;\n"])));
var IconBox = styled(Box)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\talign-self: center;\n\tcursor: pointer;\n"], ["\n\talign-self: center;\n\tcursor: pointer;\n"])));
var MenuBox = styled(Flex)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\ttext-align: center;\n\ttransition: max-height 0.4s ease-in-out;\n\talign-self: center;\n\toverflow: hidden;\n\n\ta {\n\t\twidth: 100%;\n\t\tdisplay: inline-block;\n\t}\n"], ["\n\ttext-align: center;\n\ttransition: max-height 0.4s ease-in-out;\n\talign-self: center;\n\toverflow: hidden;\n\n\ta {\n\t\twidth: 100%;\n\t\tdisplay: inline-block;\n\t}\n"])));
var BaseNavbar = (function (_super) {
    __extends(BaseNavbar, _super);
    function BaseNavbar(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            open: false,
        };
        return _this;
    }
    BaseNavbar.prototype.toggle = function () {
        this.setState({
            open: !this.state.open,
        });
    };
    BaseNavbar.prototype.render = function () {
        var _this = this;
        var _a = this.props, brand = _a.brand, children = _a.children, props = __rest(_a, ["brand", "children"]);
        return (React.createElement(Box, __assign({}, props),
            React.createElement(Container, null,
                React.createElement(Flex, { flexDirection: ['column', 'row'] },
                    React.createElement(Flex, null,
                        React.createElement(BrandBox, { minWidth: "150px", height: "auto", p: 2 }, brand),
                        children && (React.createElement(IconBox, { onClick: function () { return _this.toggle(); }, ml: ['auto', 0], p: 2, display: ['block', 'none'] }, this.state.open ? (React.createElement(FontAwesomeIcon, { icon: faTimes })) : (React.createElement(FontAwesomeIcon, { icon: faBars }))))),
                    React.createElement(MenuBox, { maxHeight: [this.state.open ? '100vh' : '0vh', 'none'], width: ['100%', 'auto'], ml: [0, 'auto'] }, children && (React.createElement(Flex, { width: ['100%', 'auto'], flexDirection: ['column', 'row'] }, React.Children.map(children, function (child, i) {
                        return (React.createElement(Box, { onClick: function () { return _this.toggle(); }, width: ['100%', 'auto'], p: 2, key: i }, child));
                    }))))))));
    };
    return BaseNavbar;
}(React.Component));
var setDefaultProps = withProps(function (props) {
    return Object.assign({
        color: 'white',
        bg: 'gray.dark',
    }, props);
});
export var Navbar = compose(setDefaultProps)(BaseNavbar);
var templateObject_1, templateObject_2, templateObject_3;
